import {
  StatusChip,
  BadgeColor,
  Text,
  Divider,
  Grid,
  useDevice,
} from "@pushpress/shared-components";
import { Card } from "@pushpress/pushpress-ui";
import { FlatFileUI } from "./FlatFileUI";

type UploadMembersCardType = {
  migratingMembersCount: number;
};

export default function UploadMembersCard({
  migratingMembersCount,
}: UploadMembersCardType) {
  const { isMobile } = useDevice();

  const flatFileButtonText =
    migratingMembersCount === 0
      ? "Upload members"
      : isMobile
      ? "Edit"
      : "Add, edit, or remove members";

  return (
    <Card className="tw-p-6 tw-mt-6">
      <Grid container spacing={3}>
        <Grid item>
          <StatusChip color={BadgeColor.Gray} label="Step 1" />
        </Grid>
        <Grid item>
          <Text variant="heading-4" component="h2" color="wolf-700">
            Upload members
          </Text>
        </Grid>
        <Grid item marginY={1}>
          <Text variant="body-lg" color="wolf-600">
            Upload a CSV of your active, paying members. DO NOT include leads,
            or ex-members. During upload, you will be able to modify member
            information, assign sub accounts, and set historical check-ins.
          </Text>
        </Grid>
        <Divider
          color="wolf-800"
          vPadding={16}
          marginLeft={24}
          marginRight={18}
        />
        <Grid item xs={6}>
          <FlatFileUI buttonText={flatFileButtonText} />
        </Grid>
        <Grid item>
          <Divider vertical color="wolf-800" />
        </Grid>
        <Grid container item justifyContent="center" xs={5} marginY={-1}>
          <Grid item>
            <Text
              variant={isMobile ? "body-sm" : "body-md"}
              component="p"
              color="wolf-600"
            >
              Members in migration
            </Text>
            <Text variant="heading-4" component="h4" align="center">
              {migratingMembersCount}
            </Text>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}
